import { ColProps } from 'antd/lib/grid';
import { TableProps } from 'antd/lib/table';
import { GeneralFunction, IPagination } from 'types/common';

export type TitleKey<T> = ColProps & {
  value: keyof T;
};

export type RowKey<T> = (keyof T | TitleKey<T>)[];

export type IMobileTableConfig<DataType> = {
  grid: RowKey<DataType>[];
  titleKeys?: RowKey<DataType>;
  onClickTitle?: (row: DataType) => void;
};

export enum MobileTableType {
  CARD = 'CARD',
  RESPONSIVE_TABLE = 'RESPONSIVE_TABLE',
}

export interface ITableProps<DataType = unknown> extends TableProps<DataType> {
  nullRender?: any;
  wrapperClassName?: string;
  meta?: IPagination;
  widthThreshold?: number;
  mobileConfig?: IMobileTableConfig<DataType>;
  mobileDesignType?: MobileTableType;
  onRowClick?: GeneralFunction;
  responsiveFullBordered?: boolean;
}

export type DataEntity = { key?: any };
